<p-toast key="{{ messageKey }}"></p-toast>

<app-hero *transloco="let t" [title]="t('page_access_requests')">
  <div class="hero-buttons">
    <p-iconfield>
      <input
        pInputText
        type="text"
        maxlength="32"
        #globalFilterInput
        (input)="
          engagementEntryTable.filterGlobal(globalFilterInput.value, 'contains')
        "
        [placeholder]="t('search')"
        class="w-64 border-transparent hero-search-input"
      />
      <p-inputicon class="icon-search-outline" />
    </p-iconfield>
  </div>
  @if (engagementEntryTable?.totalRecords; as totalRecords) {
    <span class="hero-counter">{{ totalRecords }}</span>
  }
</app-hero>

<div class="px-8" *transloco="let t">
  <div class="-mt-8 bg-white shadow-md">
    <div class="p-8">
      <p-table
        *transloco="let t"
        [value]="engagementEntries"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="['name', 'jobCode', 'managerName']"
        sortField=""
        [sortOrder]="-1"
        styleClass="p-datatable-sm log-table"
        dataKey="id"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="engagementName">
              {{ t("name") }} <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="jobCode">
              {{ t("jobcode") }} <p-sortIcon field="jobCode"></p-sortIcon>
            </th>
            <th pSortableColumn="engagementManagerName">
              {{ t("manager_name") }}
              <p-sortIcon field="engagementManagerName"></p-sortIcon>
            </th>
            <th>&nbsp;</th>
          </tr>
        </ng-template>
        <ng-template #body let-engagementEntry>
          <tr attr.data-instanceid="{{ engagementEntry.instanceId }}">
            <td>
              <span class="font-medium">{{
                engagementEntry.engagementName
              }}</span>
            </td>
            <td>
              <span class="whitespace-nowrap">{{
                engagementEntry.jobCode
              }}</span>
            </td>
            <td>
              <span class="whitespace-nowrap">{{
                engagementEntry.engagementManagerName
              }}</span>
            </td>
            <td class="text-right">
              <div class="-my-2 -mr-4">
                <button
                  pButton
                  pRipple
                  type="button"
                  class="p-button-text"
                  icon="-ml-1 -mt-2px"
                  loadingIcon="animate-spin -ml-1 -mt-2px"
                  [label]="t('manage_access')"
                  (click)="showAccessManagement(engagementEntry)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="6">
              <p
                class="p-12 italic font-normal text-center text-grey-medium/50"
              >
                {{ loading ? t("loading") : t("empty_message") }}
              </p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<app-access-management-dialog
  [(showing)]="showingAccessManagement"
  [engagement]="selectedEngagement"
/>
